<template>
  <div class="modal-mask" @mousedown="$emit('close')">
    <div class="modal-wrapper">
      <div class="modal-container" @mousedown.stop>
        <div class="modal-body">
          <slot name="body">
            <div class="modal-close">
              <div class="close">
                <img src="@/assets/img/ic_close.svg" @click="closeModal" />
              </div>
            </div>
            <div class="title-wrap">
              <div class="type">관리자용</div>
              <div class="title">사업자 정보</div>
              <div class="sub-title">
                월정산 신청 심사를 위해 아래 정보 입력은 필수에요. 😊
              </div>
              <FormulateForm
                autocomplete="off"
                v-model="vatInfo"
                #default="{ isValid }"
              >
                <FormulateInput
                  type="number-input"
                  errorBehavior="value"
                  placeholder="사업자등록번호 (-) 제외 입력"
                  name="vatNumber"
                  :validation="[['required'], ['valueLength', 10]]"
                  maxlength="10"
                  v-model="vatInfo.vatNumber"
                />
                <FormulateInput
                  type="text"
                  placeholder="대표자 성함"
                  name="representative"
                  v-model="vatInfo.representative"
                  errorBehavior="value"
                  :validation="[['required'], ['between', 2, 40]]"
                  @blur="trimOnBlur('representative')"
                />
                <FormulateInput
                  type="text"
                  placeholder="업태/업종"
                  name="conditions"
                  v-model="vatInfo.conditions"
                  errorBehavior="value"
                  :validation="[['required'], ['between', 2, 50]]"
                  @blur="trimOnBlur('conditions')"
                />
                <FormulateInput
                  type="text"
                  placeholder="사업장 주소"
                  name="address"
                  errorBehavior="value"
                  maxlength="255"
                  v-model="vatInfo.address"
                  :validation="[['required'], ['between', 4, 255, 'address']]"
                  @blur="trimOnBlur('address')"
                />
                <FormulateInput
                  type="text"
                  placeholder="세금계산서 이메일"
                  name="email"
                  errorBehavior="value"
                  v-model.trim="vatInfo.email"
                  :validation="[['required'], ['validateEmail']]"
                />
                <div class="file-wrap">
                  <div class="file-box">
                    <div class="file-title">
                      <div class="for-mobile">
                        <img src="@/assets/img/ic_link.svg" />
                        <div class="image-title">사업자등록증</div>
                      </div>
                      <div class="file-name">{{ fileUploadProcess }}</div>
                    </div>
                    <div class="file-button" @click="selectFile">
                      <span v-if="!imageLoading">첨부하기</span>
                      <div v-else>
                        <i class="far fa-spinner fa-spin" />
                      </div>
                    </div>
                  </div>
                  <input
                    id="file"
                    type="file"
                    style="display: none"
                    @change="onFileChange"
                  />
                  <input v-model="vatInfo.licenseImage" style="display: none" />
                </div>
                <div class="btn-wrap">
                  <button
                    @click="submitVatInfo"
                    :disabled="!isValid || !vatInfo.licenseImage"
                  >
                    <div v-if="!isLoading">수정 완료</div>
                    <div v-else>
                      <i class="far fa-spinner fa-spin" />
                    </div>
                  </button>
                </div>
              </FormulateForm>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<style src="./../ModalCommon.css" scoped></style>
<style src="./layout.css" scoped></style>

<script>
import axios from "@/helpers/axios";
/* eslint-disable */
export default {
  name: "vatInformation",
  props: ["isChange"],
  methods: {
    closeModal() {
      this.$emit("close");
    },

    trimOnBlur(key) {
      this.vatInfo[key] = this.vatInfo[key].replace(/ +/g, " ");
      this.vatInfo[key] = this.vatInfo[key].replace(/^\s+|\s+$/g, "");
    },

    //기존 정보 저장
    async setInfo() {
      if (this.isChange) {
        try {
          const result =
            this.$store.getters["auth/tokenPayload"]().type === "member"
              ? await this.$store.dispatch("users/biz_member_myInfo")
              : await this.$store.dispatch("users/biz_manager_myInfo");
          if (!result.success) {
            return;
          }

          this.beforVatInfo = result.information.vatInfo;
          for (let [key, value] of Object.entries(this.beforVatInfo)) {
            this.vatInfo[key] = value ? value : "";
          }

          this.vatInfo.licenseImage
            ? (this.fileUploadProcess = "첨부완료")
            : (this.fileUploadProcess = "첨부파일이 없습니다.");
        } catch (e) {
          await this.$store.dispatch("auth/signout");
          this.$router.push("/");
        }
      }
    },

    async submitVatInfo() {
      this.isLoading = true;
      //기존 정보와 다른 정보만 전송
      let vat = {};
      let isChange = false;

      for (let [key, value] of Object.entries(this.vatInfo)) {
        if (this.beforVatInfo[key] !== this.vatInfo[key]) {
          isChange = true;
          vat[key] = value;
        }
      }

      if (!isChange) {
        this.isLoading = false;
        this.closeModal();
        return;
      }

      const payload = {
        vatInfo: vat
      };

      try {
        const result = await this.$store.dispatch(
          "users/changeVatInformation",
          payload
        );
        if (!result.success) {
          alert("정보 변경 중 오류가 발생하였습니다.");
          this.isLoading = false;
          console.error(result);
        } else {
          this.isLoading = false;
          this.closeModal();
          this.$emit("resetInfo");
          this.step++;
          alert("사업자 정보 변경이 완료되었습니다.");
        }
      } catch (e) {
        this.isLoading = false;
        alert("정보 변경 중 오류가 발생하였습니다.");
      }
    },

    //사업자등록증 이미지 업로드 관련
    extension(val) {
      // return val.match(/[.]/);
      return val.split(".").pop().toLowerCase();
    },
    selectFile() {
      document.getElementById("file").click();
    },
    onFileChange(e) {
      this.imageLoading = true;
      const file = e.target.files[0];
      const allowedExtension = ["jpg", "png", "gif", "jpeg"];

      if (allowedExtension.indexOf(this.extension(file.name)) === -1) {
        this.imageLoading = false;
        return alert("이미지파일만 업로드 가능합니다");
      }

      const form = new FormData();
      form.append("image", file);

      const progressEvt = {
        onUploadProgress: (evt) => {
          const percent = Math.round((evt.loaded * 100) / evt.total);
          this.fileUploadProcess = `파일업로드 ... ${percent}%`;
        }
      };

      axios
        .post("/images/corp-license", form, {
          progressEvt,
          headers: {
            bypass: true
          }
        })
        .then((result) => {
          this.fileUploadProcess = file.name;
          this.vatInfo.licenseImage = result.data.url;
          this.imageLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.fileUploadProcess = "이미지파일 첨부가능";
          this.vatInfo.licenseImage = "";
        });
    }
  },
  async mounted() {
    await this.setInfo();
    document.body.style.overflow = "hidden";
  },

  destroyed() {
    document.body.style.overflow = "unset";
  },
  data() {
    return {
      beforVatInfo: {},
      vatInfo: {},
      fileUploadProcess: "",
      imageLoading: false,
      isLoading: false
    };
  }
};
</script>
